import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "app/components/ui/button";

export const RequestSubmission = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center bg-white w-full max-w-[34.8125rem] space-y-4 sm:space-y-5 lg:space-y-6 p-4 sm:p-5 md:p-6 lg:p-[1.625rem] border border-[#E5E7EB] rounded-lg md:rounded-2xl mx-auto">
      <div className="space-y-3 sm:space-y-4 lg:space-y-5">
        <div className="flex-shrink-0 size-11 sm:size-[3.25rem] lg:size-[3.75rem] mx-auto">
          <img src="/assets/green-tick.svg" alt="Success" className="w-full" />
        </div>
        <div className="text-center">
          <h2 className="font-mobile text-black text-xl sm:text-2xl lg:text-[1.75rem] font-bold leading-7 sm:leading-9 lg:leading-[2.75rem] mb-0.5 sm:mb-1">
            Request Submitted Successfully
          </h2>
          <p className="max-w-[30.3125rem] text-black text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5 lg:leading-[1.30375rem] mx-auto">
            Your DID change request has been processed and is now in queue
          </p>
        </div>
      </div>
      <ul className="w-full bg-[#F8F9FA] p-3 sm:p-3.5 lg:p-4 rounded-[0.5625rem]">
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Request ID
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            AH0619251
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Phone Number
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            (555)123-1234
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Current DID
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            4567876543214576
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Requested Change
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            New DID Assignment
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            ZIP Code
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            10001
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 border-b border-[#E9EAEB]">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Submitted By
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            Agent ID: AG-2024-156
          </p>
        </li>
        <li className="flex items-center justify-between min-h-[3.625rem] px-4 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3">
          <h6 className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-bold leading-4 sm:leading-5">
            Submission Time
          </h6>
          <p className="text-black text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
            6/27/2025, 10:52:29 AM
          </p>
        </li>
      </ul>
      <Button
        type="button"
        variant="primary"
        className="h-11 sm:h-[2.875rem] md:h-12 lg:h-[3.125rem]"
        onClick={() => navigate("/agent/customer-dashboard")}
      >
        Back to Dashboard
      </Button>
    </div>
  );
};
